export const SCHEMA_NAME = "WarrantWaitForInfo";

export const FIELDS = {
  WAIT_FOR_BODY_RECEIVED: "waitForBodyReceived",
  WAIT_FOR_BY_STAFF_ID: "waitForByStaffID",
  WAIT_FOR_COMMENTS: "waitForComments",
  WAIT_FOR_DATE: "waitForDate",
  WAIT_FOR_MONEY_RECEIVED: "waitForMoneyReceived",
  WAIT_FOR_REASON_ID: "waitForReasonID",
  WAIT_FOR_RECEIVED_DATE: "waitForReceivedDate",
  WAIT_FOR_TIME: "waitForTime",
  WARRANT_ID: "warrantID",
  WARRANT_WAIT_FOR_INFO_ID: "warrantWaitForInfoID",
};
